import { processName } from '@bit/gerenciatd.utils.ada-byron';
import { api } from '@bit/gerenciatd.utils.monitoring-utils';
import { MethodType } from '@bit/gerenciatd.utils.types';
import Request, { getMockedInfo } from '@bit/gerenciatd.utils.request';
import Sonda from '@bit/gerenciatd.utils.sonda';

enum PATHS {
  GET_PRODUCTS_LIST = '/v1/orion/standard-api/products/list',
  GET_PRODUCT_BY_ALIAS = '/v1/orion/standard-api/products/alias/',
  GET_CATEGORIES_TREE = '/v1/orion/standard-api/categories/tree',
  GET_PRODUCT_BY_RULES = '/v1/orion/standard-api/products/ionCode'
}

const getProductsByCategorySuccess = (xhr: any) => {
  const response = JSON.parse(xhr.response);
  return response.responseList;
};

const getProductByAliasSuccess = (xhr: any) => {
  const response = JSON.parse(xhr.response);
  return response;
};

const getCategoriesTreeSuccess = (xhr: any) => {
  const response = JSON.parse(xhr.response);
  return response;
};
const getProductByRulesSuccess = (xhr: any) => {
  const response = JSON.parse(xhr.response);
  return response;
};

export const getProductByAlias = (
  data: {
    alias: string;
  },
  context: any,
  idFront = 'VT',
): Promise<any> => {
  const idRequest = api.getUUID(idFront);
  const sonda = new Sonda({
    eventName: 'ORION.GET_PRODUCT_BY_ALIAS',
    context,
    uniqueId: idRequest,
    origin: processName,
  });

  const { orion: connectionData, name } = context.environment;
  const { endpoint: host, headers } = connectionData;
  const { alias } = data;

  const URL_API = `${host}${PATHS.GET_PRODUCT_BY_ALIAS}${alias}?${idRequest}&rules={}`;

  const mockInfo = getMockedInfo('getProductByAlias', name);

  try {
    const request = new Request({
      method: MethodType.GET,
      endpoint: URL_API,
      onSuccess: (response) => getProductByAliasSuccess(response),
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};

export const getProductsByCategory = (
  data: {
    category: string;
  },
  context: any,
  idFront = 'VT',
): Promise<any> => {
  const idRequest = api.getUUID(idFront);
  const sonda = new Sonda({
    eventName: 'ORION.GET_PRODUCTS_LIST',
    context,
    uniqueId: idRequest,
    origin: processName,
  });

  const { orion: connectionData, name } = context.environment;
  const { endpoint: host, headers } = connectionData;
  const { category } = data;

  const URL_API = `${host}${PATHS.GET_PRODUCTS_LIST}?categories=${category}&${idRequest}&rules={}`;

  const mockInfo = getMockedInfo('getProductsByCategory', name);

  try {
    const request = new Request({
      method: MethodType.GET,
      endpoint: URL_API,
      onSuccess: (response) => getProductsByCategorySuccess(response),
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};

export const getCategoriesTree = (
  data: {
    category: string;
  },
  context: any,
  idFront = 'VT',
): Promise<any> => {
  const idRequest = api.getUUID(idFront);
  const sonda = new Sonda({
    eventName: 'ORION.GET_CATEGORIES_TREE',
    context,
    uniqueId: idRequest,
    origin: processName,
  });

  const { orion: connectionData, name } = context.environment;
  const { endpoint: host, headers } = connectionData;
  const { category } = data;

  const URL_API = `${host}${PATHS.GET_CATEGORIES_TREE}?id=${category}&${idRequest}&rules={}`;

  const mockInfo = getMockedInfo('getCategoriesTree', name);

  try {
    const request = new Request({
      method: MethodType.GET,
      endpoint: URL_API,
      onSuccess: (response) => getCategoriesTreeSuccess(response),
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};


export const getProductByRules = (
  data: {
    rules: any,
    ionCode: string,
  },
  context: any,
  idFront = 'webM',
): Promise<any> => {
  const idRequest = api.getUUID(idFront);
  const sonda = new Sonda({
    eventName: 'ORION.GET_PRODUCT_BY_RULES',
    context,
    uniqueId: idRequest,
    origin: processName,
  });

  const { orion: connectionData, name } = context.environment;
  const { endpoint: host, headers } = connectionData;
  const { rules, ionCode } = data;

  const URL_API = `${host}${PATHS.GET_PRODUCT_BY_RULES}/${ionCode}?rules=${encodeURIComponent(rules)}&${idRequest}`;

  const mockInfo = getMockedInfo('getProductByRules', name);

  try {
    const request = new Request({
      method: MethodType.GET,
      endpoint: URL_API,
      onSuccess: (response) => getProductByRulesSuccess(response),
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};